import axios from 'axios'
import { BUSCAR_TIPOS_DOCUMENTOS } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default () => dispatch => axios.get(`${URL}/pessoas/tipos-documentos`,SLOW_REQUEST_CONFIG)
  .then(response => dispatch({
    type: BUSCAR_TIPOS_DOCUMENTOS,
    payload: response
  }));
